import { Component, Input, OnInit } from '@angular/core';
import { ArquivoService } from '@core/services/arquivo.service';
import FileSaver from 'file-saver';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-movimentacao-societaria-exportar-modal',
  templateUrl: './movimentacao-societaria-exportar-modal.component.html',
  styleUrls: ['./movimentacao-societaria-exportar-modal.component.scss']
})
export class MovimentacaoSocietariaExportarModalComponent {

  @Input() documentoId!: any;

  constructor(
    private modalRef: NzModalRef,
    private arquivoService: ArquivoService,
  ) {}

  exportarExcel() {
    this.arquivoService.downloadArquivo(this.documentoId).subscribe(
      (response: any) => {
        let fileName = response.headers.get('filename');
        FileSaver.saveAs(response.body, fileName);
      }
    );
  }

  exportarWord() {
    this.arquivoService.downloadArquivo(this.documentoId).subscribe(
      (response: any) => {
        let fileName = response.headers.get('filename');
        FileSaver.saveAs(response.body, fileName);
      }
    );
  }

  exportarPdf() {
    this.arquivoService.downloadArquivo(this.documentoId).subscribe(
      (response: any) => {
        let fileName = response.headers.get('filename');
        FileSaver.saveAs(response.body, fileName);
      }
    );
  }


  fecharModal(): void {
    this.modalRef.close();
  }
}
